module.exports = __webpack_public_path__ + "img/Tableau report search.fb709975.png";